<template>
  <div>
    <div class="vg-content">
      <div class="header">
        <van-image class="information" width="24" height="24" :src="srcInformation" @click="onInformation"/>
        <div class="information-box" v-if="showInformation">
          <div class="border-triangle"></div>
          <div class="box-text">同一个月份、同一个项目、同一个计费科目的订单可以批量开票</div>
        </div>
        <div class="shade" v-if="showInformation" @click="onShadeClose"></div>

        <van-tabs class="vg-tabs" type="card" v-model="activeName">
          <van-tab title="待开票" name="Pending"/>
          <van-tab title="开票中" name="InHand"/>
          <van-tab title="已开票" name="Finish"/>
        </van-tabs>
        <vg-invoice-filter-picker :original-date="filterDate" :original-project="filterProject"
                                  :original-subject="filterSubject"
                                  :order-type="orderType" :order-phone-num="phoneNum"
                                  @on-invoice-filter="onInvoiceFilter"/>
      </div>
      <div class="filter-text">{{ filterStr }}</div>

      <template>
        <vg-pull-refresh-list
            ref="list"
            v-show="isActive"
            :onLoadPage="onLoadPagePending"
            @loaded="onLoadedPending"
            :min-height="'calc(100vh - 100px)'"
            :logo-padding-bottom="'100px'"
            v-slot="{items}"
        >
          <div class="item-content" v-for="(item, index) in items" :key="item.id">
            <van-checkbox class="checkbox" v-model="item.selected" icon-size="22px" shape="square"
                          @click="onItemClick(index, false)"/>
            <div class="item" @click="onItemClick(index, true)">
              <div>
                <div class="item-entry" style="margin-top: 0px;">
                  <div class="item-title">支付时间：</div>
                  <div class="item-text">{{ item.paymentTimeStr }}</div>
                </div>
                <div class="item-entry">
                  <div class="item-title">项目：</div>
                  <div class="item-text">{{ item.projectName }}</div>
                </div>
                <div class="item-entry">
                  <div class="item-title">计费科目：</div>
                  <div class="item-text">{{ item.billingSubject }}</div>
                </div>
                <div class="item-entry">
                  <div class="item-title">子计费科目：</div>
                  <div class="item-text">{{ item.billingSubSubject ? item.billingSubSubject : item.billingSubject }}</div>
                </div>
                <div class="item-entry">
                  <div class="item-title">缴费金额：</div>
                  <div class="item-text" style="color: #2897FF;">¥{{ item.paymentAmount }}</div>
                </div>
              </div>
            </div>
          </div>
        </vg-pull-refresh-list>
      </template>

      <template>
        <vg-pull-refresh-list
            ref="listInHand"
            v-show="!isActive"
            :onLoadPage="onLoadPageInHand"
            :min-height="'calc(100vh - 100px)'"
            :logo-padding-bottom="'100px'"
            v-slot="{items}"
        >
          <div class="item-content" v-for="item in items" :key="item.id" @click="onInvoiceClick(item)">
            <div class="item">
              <div>
                <div class="item-entry" style="margin-top: 0px;">
                  <div class="item-title">申请时间：</div>
                  <div class="item-text">{{ item.createTime | datetime }}</div>
                </div>
                <div class="item-entry">
                  <div class="item-title">订单数量：</div>
                  <div class="item-text">{{ item.totalNumber }}笔订单</div>
                </div>
                <div class="item-entry">
                  <div class="item-title">开票金额：</div>
                  <div class="item-text" style="color: #2897FF;">¥{{ item.totalAmount }}</div>
                </div>
              </div>
              <div class="item-arrow"/>
            </div>
          </div>
        </vg-pull-refresh-list>
      </template>
    </div>
    <div class="footer" v-show="isActive">
      <van-checkbox v-if="!isSingle" style="margin-left: 15px;" v-model="checkedAll" icon-size="22px" shape="square" @click="onCheckedAll"/>
      <div v-if="!isSingle" class="item-text" style="margin-left: 10px;margin-right: -15px;">全选</div>
      <van-button class="button" @click="onInvoice" :disabled="!isSelected">立即开票</van-button>
    </div>
  </div>
</template>

<script>
import {Button, Checkbox, Image as VanImage, Tab, Tabs, Toast} from "vant";
import VgPullRefreshList from "@/components/Commons/VgPullRefreshList";
import srcFilter from "@/assets/scanverify/filter.svg";
import srcInformation from "@/assets/information.svg";
import {client} from "@/libraries/http";
import VgInvoiceFilterPicker from "@/components/VgInvoiceFilterPicker";

export default {
  name: "ChargeInvoice",
  components: {
    VgInvoiceFilterPicker,
    VanImage,
    "van-tabs": Tabs,
    "van-tab": Tab,
    VgPullRefreshList,
    "van-checkbox": Checkbox,
    "van-button": Button,
  },
  data() {
    return {
      srcFilter: srcFilter,
      srcInformation: srcInformation,
      activeName: "Pending",
      isActive: true,
      checkedAll: false,
      filterProject: {},
      filterSubject: {},
      filterDate: undefined,
      filterStr: "",
      showInformation: false,
      orderType: "SPORADIC_CHARGE",
      phoneNum: "",
      records: [],
      invoices: [],
      isSingle: false,
    }
  },
  created() {
    console.log(this.$route);
    this.phoneNum = this.$route.query.phoneNum;
    this.filterStr = this.getFilterStr();
    window.addEventListener("pageshow", this.pageShow);
  },
  destroyed() {
    window.removeEventListener("pageshow", this.pageShow);
  },
  watch: {
    activeName() {
      this.isActive = this.activeName === "Pending";
      if (this.isActive) {
        this.$refs.list.onRefresh();
      } else {
        this.$refs.listInHand.onRefresh();
      }
    },
  },
  computed: {
    isSelected() {
      for (let x in this.records) {
        if (this.records[x].checked)
          return true;
      }
      return false;
    },
  },
  methods: {
    pageShow() {
      console.log("pageShow..." + this.isShowed)
      if (this.isShowed) {
        this.$router.go(0)
      }
      this.isShowed = true
    },
    onLoadPagePending({page, size}) {
      console.log("onLoadPagePending: " + page + ", " + size);
      return client.get("/api/h5/invoice/page" + this.getPendingQuery(page, size), {headers: {'Disable-Loading': 'Yes'}}
      ).then(res => {
        console.log(res);
        let records = res.data.content;
        for (let x in records) {
          records[x].checked = false;
          records[x].selected = false;
        }
        return {
          models: records,
          finished: records.length < size,
        };
      })
    },
    onLoadedPending(items) {
      this.records = items;
      this.checkedAll = this.getCheckedAll();
    },
    getPendingQuery(page, size) {
      let query = "?phoneNum=" + this.phoneNum;
      query += "&orderType=" + this.orderType;
      if (this.filterProject?.projectId) {
        query += "&projectId=" + this.filterProject?.projectId;
      }
      if (this.filterSubject?.id) {
        query += "&billingSubjectId=" + this.filterSubject?.id;
      }
      if (this.filterDate?.year > 0 && this.filterDate?.month > 0) {
        query += "&month=";
        query += this.filterDate.year + "-" + (this.filterDate.month < 10 ? "0" + this.filterDate.month : this.filterDate.month);
      }
      query += "&page=" + page;
      query += "&size=" + size;
      return query;
    },
    onLoadPageInHand({page, size}) {
      console.log("onLoadPageInHand: " + page + ", " + size);
      return client.get("/api/h5/invoice/receipt/page" + this.getInHandQuery(page, size), {headers: {'Disable-Loading': 'Yes'}}
      ).then(res => {
        console.log(res);
        return {
          models: res.data.content,
          finished: res.data.content.length < size,
        };
      })
    },
    getInHandQuery(page, size) {
      let query = "?phoneNum=" + this.phoneNum;
      query += "&orderType=" + this.orderType;
      if (this.filterProject?.projectId) {
        query += "&projectId=" + this.filterProject?.projectId;
      }
      if (this.filterSubject?.id) {
        query += "&billingSubjectId=" + this.filterSubject?.id;
      }
      if (this.filterDate?.year > 0 && this.filterDate?.month > 0) {
        query += "&month=";
        query += this.filterDate.year + "-" + (this.filterDate.month < 10 ? "0" + this.filterDate.month : this.filterDate.month);
      }
      query += "&page=" + page;
      query += "&size=" + size;
      query += "&invoiceStatus=" + (this.activeName === "InHand" ? "INVOICING" : "INVOICED");
      return query;
    },
    onItemClick(index, isSelf) {
      if (this.isActive) {
        if (!this.checkProject(index)) {
          Toast("批量开票请选择同一个项目");
          if (!isSelf) this.records[index].selected = false;
          return;
        }
        if (!this.checkMonth(index)) {
          Toast("批量开票请选择同一月份");
          if (!isSelf) this.records[index].selected = false;
          return;
        }
        if (!this.checkSubject(index)) {
          Toast("批量开票请选择同一个计费科目");
          if (!isSelf) this.records[index].selected = false;
          return;
        }
        if (isSelf) this.records[index].selected = !this.records[index].checked;
        this.records[index].checked = !this.records[index].checked;
        if (this.isSingle) this.singleChecked(index);
        this.checkedAll = this.getCheckedAll();
      } else {
        // alert("跳转到票易通发票页面");
      }
    },
    onCheckedAll() {
      if (this.checkedAll) {
        let projectId, month, subject;
        for (let x in this.records) {
          if (projectId && projectId !== this.records[x].projectId) {
            Toast("批量开票请选择同一个项目");
            this.checkedAll = false;
            return;
          }
          projectId = this.records[x].projectId;
          if (month && month !== this.records[x].month) {
            Toast("批量开票请选择同一月份");
            this.checkedAll = false;
            return;
          }
          month = this.records[x].month;
          if (subject && subject !== this.records[x].billingSubject) {
            Toast("批量开票请选择同一个计费科目");
            this.checkedAll = false;
            return;
          }
          subject = this.records[x].billingSubject;
        }
      }
      for (let x in this.records) {
        this.records[x].checked = this.checkedAll;
        this.records[x].selected = this.checkedAll;
      }
    },
    getCheckedAll() {
      let isAll = this.records?.length > 0;
      for (let x in this.records) {
        isAll &= this.records[x].checked;
      }
      return isAll;
    },
    onInvoice() {
      // alert("跳转到票易通页面进行开票");
      let ids = [];
      for (let x in this.records) {
        if (this.records[x].checked)
          ids.push(this.records[x].id);
      }
      let month = null;
      if (this.filterDate?.year > 0 && this.filterDate?.month > 0) {
        month = this.filterDate.year + "-" + (this.filterDate.month < 10 ? "0" + this.filterDate.month : this.filterDate.month);
      }
      let params = {
        phoneNum: this.phoneNum,
        orderType: this.orderType,
        projectId: this.filterProject?.projectId,
        billingSubjectId: this.filterSubject?.id,
        month: month,
        orderIds: ids
      };
      client.post("/api/h5/invoice/bulk", params).then((res) => {
        window.location.href = res.data;
      });
    },
    checkProject(index) {
      if (this.isSingle) return true;
      if (!this.records[index].checked) {
        let projectId;
        for (let x in this.records) {
          if (this.records[x].checked) {
            projectId = this.records[x].projectId;
            break;
          }
        }
        return !projectId || projectId === this.records[index].projectId;
      }
      return true;
    },
    checkMonth(index) {
      if (this.isSingle) return true;
      if (!this.records[index].checked) {
        let month;
        for (let x in this.records) {
          if (this.records[x].checked) {
            month = this.records[x].month;
            break;
          }
        }
        return !month || month === this.records[index].month;
      }
      return true;
    },
    checkSubject(index) {
      if (this.isSingle) return true;
      if (!this.records[index].checked) {
        let subject;
        for (let x in this.records) {
          if (this.records[x].checked) {
            subject = this.records[x].billingSubject;
            break;
          }
        }
        return !subject || subject === this.records[index].billingSubject;
      }
      return true;
    },
    onInformation() {
      this.showInformation = !this.showInformation;
    },
    onShadeClose() {
      this.showInformation = false;
    },
    onInvoiceFilter(date, project, subject) {
      console.log(date);
      console.log(project);
      console.log(subject);
      this.filterDate = date;
      this.filterProject = project ?? {};
      this.filterSubject = subject ?? {};
      this.filterStr = this.getFilterStr();
      if (this.isActive) {
        this.$refs.list.onRefresh();
      } else {
        this.$refs.listInHand.onRefresh();
      }
    },
    getFilterStr() {
      let str = "订单时间：";
      if (this.filterDate?.year > 0 && this.filterDate?.month > 0) {
        str += this.filterDate.year + "-" + (this.filterDate.month < 10 ? "0" + this.filterDate.month : this.filterDate.month);
      } else {
        str += "无限制";
      }
      str += "，项目：";
      str += this.filterProject && this.filterProject.projectId ? this.filterProject.projectName : "无限制";
      str += "，计费科目：";
      str += this.filterSubject && this.filterSubject.id ? this.filterSubject.name : "无限制";
      return str;
    },
    onInvoiceClick(item) {
      console.log(item);
      // let newWindow = window.open('', '_blank');
      client.get("/api/h5/invoice/url?id=" + item.id + "&phoneNum=" + this.phoneNum).then((res) => {
        window.location.href = res.data;

        // let a = document.createElement('a');
        // a.setAttribute('href', res.data);
        // a.setAttribute('target', '_self');
        // document.body.appendChild(a);
        // a.click();
        // a.remove();
      });
    },
    singleChecked(index) {
      if (this.records[index].checked) {
        let id = this.records[index].id;
        for (let x in this.records) {
          if (id !== this.records[x].id) {
            this.records[x].checked = false;
            this.records[x].selected = false;
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.vg-content {
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: stretch;
}

.header {
  margin: 15px 40px 0;
  display: flex;
  align-items: center;
}

.vg-tabs {
  flex-grow: 1;
}

.vg-tabs >>> .van-tabs__wrap {
  height: 35px;
}

.vg-tabs >>> .van-tabs__nav {
  box-sizing: border-box;
  height: 35px;
  margin: 0px;
  border: 1px solid #2897FF;
  border-radius: 18px;
  background-color: #fff;
}

.vg-tabs >>> .van-tab {
  padding: 0;
  font-size: 14px;
  color: #2897FF;
  border-right: 1px solid #2897FF;
}

.vg-tabs >>> .van-tab:last-child {
  border-right: none;
}

.vg-tabs >>> .van-tab.van-tab--active {
  color: #fff;
  background-color: #2897FF;
}

.vg-tabs >>> .van-tab--active:first-child {
  border-radius: 18px 0px 0px 18px;
}

.vg-tabs >>> .van-tab--active:last-child {
  border-radius: 0px 18px 18px 0px;
}

.information {
  position: absolute;
  left: 15px;
}

.filter {
  position: absolute;
  right: 15px;
}

.filter-text {
  align-self: stretch;
  color: #2897FF;
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.item {
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  background-color: #FFFFFF;
}

.checkbox {
  margin-right: 10px;
  flex-shrink: 0;
}

.item-content {
  margin-top: 10px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: stretch;
}

.item-entry {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 95px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #000000;
}

.item-arrow {
  margin-left: 15px;
  float: right;
  height: 20px;
  width: 20px;
  background-image: url("@/assets/right_arrow.svg");
}

.footer {
  width: 100%;
  z-index: 2;
  position: fixed;
  bottom: 20px;
  display: flex;
  justify-content: stretch;
  align-items: center;
  /*background: #FFFFFF;*/
  /*padding: 10px 0 20px;*/
  /*border-top: 0.5px solid #EDEBED;*/
}

.button {
  flex-grow: 1;
  height: 44px;
  margin-left: 30px;
  margin-right: 30px;
  background-color: #4BA9F6;
  color: white;
  border-radius: 8px;
  font-size: 16px;
}

.button.van-button--disabled {
  cursor: not-allowed;
  background-color: #DCDCDC;
  opacity: 1;
}

.information-box {
  position: absolute;
  left: 40px;
  right: 15px;
  top: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: stretch;
}

.box-text {
  /*min-height: 40px;*/
  padding: 12px;
  line-height: 20px;
  border-radius: 6px;
  background-color: #2897FF;
  color: #FFFFFF;
  font-size: 14px;
  text-align: left;
  flex-grow: 1;
}

.border-triangle {
  align-self: flex-start;
  margin-top: 18px;
  border-color: transparent #2897FF transparent transparent;
  border-style: solid;
  border-width: 5px 6px 5px 0px;
  height: 0;
  width: 0;
}

.shade {
  position: fixed;
  background: transparent;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 11;
}

</style>
